module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imgcenter"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "id": "img7-1",
      "src": "images/img7-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("At 8.30 pm, 2 April 1917, President Wilson appeared before Congress, sitting in joint session, and read his message recommending that a state of war be declared to exist between the United States and the Imperial German Government. The war resolution was passed by the Senate 4 April and by the House 6 April 1917. It was signed by the President and became effective the same day.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ea010da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/01b-a_AMERICAN_EXPEDITIONARY_FORCE.vue
// module id = 78
// module chunks = 0